import {
    createSlice,
    createAsyncThunk
} from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import {
    getAllProductHistoriesByAccountId
} from 'services/RequestDataService';
import { ProductHistoryInfoDto } from 'data/CustomerPortalTypes';
import moment from 'moment';


export const fetchAllProductHistoryInfo = createAsyncThunk(
    'fetchAllProductHistoryInfo',
    async (accountId: number) => {
        return await getAllProductHistoriesByAccountId(accountId);
    });

type AllProductHistoryInfoState = {
    [key: number]: ProductHistoryInfoDto[] | null
}

const initialState: AllProductHistoryInfoState = {};

const allProductHistoryInfoSlice = createSlice({
    name: 'allProductHistories',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllProductHistoryInfo.fulfilled, (state, action) => {

            if (action?.payload?.success !== true) {

                return;
            }

            return {
                ...state,
                [action.meta.arg.toString()]: action.payload.data ?? []
            };
        })
    },
});

export default allProductHistoryInfoSlice.reducer;

export const getCurrentAccountExistWolesaleAccountServices = (state: RootState): number[] | undefined => {
    if (state?.user?.data?.currentAccount?.accountId) {
        var productHistoryInfo = state.allProductHistoryInfo[state.user.data.currentAccount.accountId]
        var serviceIds = productHistoryInfo?.filter(x => x.isWholeSale).map(x => x.accountServiceId)
        return serviceIds;
    }
    return undefined;
}

export const getCurrentAccountAllProductHistoryInfo = (state: RootState): ProductHistoryInfoDto[] | null | undefined =>
    state?.user?.data?.currentAccount?.accountId
        ? state.allProductHistoryInfo[state.user.data.currentAccount.accountId]
        : undefined;
